"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSubscriptionEntitlementsDto = instanceOfSubscriptionEntitlementsDto;
exports.SubscriptionEntitlementsDtoFromJSON = SubscriptionEntitlementsDtoFromJSON;
exports.SubscriptionEntitlementsDtoFromJSONTyped = SubscriptionEntitlementsDtoFromJSONTyped;
exports.SubscriptionEntitlementsDtoToJSON = SubscriptionEntitlementsDtoToJSON;
exports.SubscriptionEntitlementsDtoToJSONTyped = SubscriptionEntitlementsDtoToJSONTyped;
/**
 * Check if a given object implements the SubscriptionEntitlementsDto interface.
 */
function instanceOfSubscriptionEntitlementsDto(value) {
    if (!('sportsLimit' in value) || value['sportsLimit'] === undefined)
        return false;
    if (!('swapsLimit' in value) || value['swapsLimit'] === undefined)
        return false;
    if (!('swapsUsed' in value) || value['swapsUsed'] === undefined)
        return false;
    if (!('swapsRemaining' in value) || value['swapsRemaining'] === undefined)
        return false;
    if (!('freeSwapUsed' in value) || value['freeSwapUsed'] === undefined)
        return false;
    if (!('annualSwapsRemaining' in value) || value['annualSwapsRemaining'] === undefined)
        return false;
    return true;
}
function SubscriptionEntitlementsDtoFromJSON(json) {
    return SubscriptionEntitlementsDtoFromJSONTyped(json, false);
}
function SubscriptionEntitlementsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sportsLimit': json['sportsLimit'],
        'swapsLimit': json['swapsLimit'],
        'swapsUsed': json['swapsUsed'],
        'swapsRemaining': json['swapsRemaining'],
        'freeSwapUsed': json['freeSwapUsed'],
        'annualSwapsRemaining': json['annualSwapsRemaining'],
        'swapsResetAt': json['swapsResetAt'] == null ? undefined : json['swapsResetAt'],
    };
}
function SubscriptionEntitlementsDtoToJSON(json) {
    return SubscriptionEntitlementsDtoToJSONTyped(json, false);
}
function SubscriptionEntitlementsDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'sportsLimit': value['sportsLimit'],
        'swapsLimit': value['swapsLimit'],
        'swapsUsed': value['swapsUsed'],
        'swapsRemaining': value['swapsRemaining'],
        'freeSwapUsed': value['freeSwapUsed'],
        'annualSwapsRemaining': value['annualSwapsRemaining'],
        'swapsResetAt': value['swapsResetAt'],
    };
}
